import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("li", { class: "nav-item mt-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_url = _resolveComponent("url")!
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_tab_pane, {
      name: "oasis",
      tab: "Oasis"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_url, {
          model: _ctx.link,
          class: _normalizeClass(`nav-link text-active-primary ms-0 me-10 py-5 ${_ctx.IsActive(
        _ctx.SetCulture(_ctx.link)
      )}`)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }, 8, ["model", "class"])
      ]),
      _: 1
    }),
    _hoisted_1
  ], 64))
}